import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { RacesService } from '../races/races.service';
import { Race } from './race';
import { RaceService } from './race.service';

@Injectable({
  providedIn: 'root'
})
export class Race$Resolver implements Resolve<Observable<Race>> {

  constructor(
    private readonly racesService: RacesService,
    private readonly raceService: RaceService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Observable<Race>> {
    return of(this.racesService.racePlan$(route.params.racePlanId).pipe(
      map((racePlan) => this.raceService.createRace(racePlan)),
      shareReplay({
        refCount: true,
        bufferSize: 1
      })
    ));
  }
}
